import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  background-color: black;
  color: white;
  max-width: 390px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  width: 100%;
  background-color: black;
  z-index: 10;
`;

const BackButton = styled.span`
  cursor: pointer;
  color: white;
  font-weight: 500;
  font-size: 16px;
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0;
`;

const Form = styled.form`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: white;
`;

const Input = styled.input`
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 6px;
  padding: 12px;
  color: white;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #17A2B8;
  }
  
  &::placeholder {
    color: #666;
  }
`;

const TextArea = styled.textarea`
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 6px;
  padding: 12px;
  color: white;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #17A2B8;
  }
  
  &::placeholder {
    color: #666;
  }
`;

const Select = styled.select`
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 6px;
  padding: 12px;
  color: white;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #17A2B8;
  }
  
  option {
    background: #1a1a1a;
    color: white;
  }
`;

const SubmitButton = styled.button`
  background: #17A2B8;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 20px;
  
  &:hover {
    background: #138496;
  }
  
  &:disabled {
    background: #333;
    cursor: not-allowed;
  }
`;

const CreateListing = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        description: '',
        price: '',
        contact: '',
        location: ''
    });

    const categories = [
        'Music Equipment',
        'Studio Services',
        'Event Spaces',
        'Photography',
        'Digital Services'
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Mock submission - in real app would send to backend
        console.log('Creating listing:', formData);
        alert('Listing created successfully!');
        navigate('/catalog/my-listings');
    };

    const handleBackClick = () => {
        navigate('/catalog');
    };

    return (
        <Container>
            <Header>
                <BackButton onClick={handleBackClick}>← Back</BackButton>
                <Title>Create Listing</Title>
                <div></div>
            </Header>
            
            <Form onSubmit={handleSubmit}>
                <FormGroup>
                    <Label>Title</Label>
                    <Input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        placeholder="Enter listing title"
                        required
                    />
                </FormGroup>

                <FormGroup>
                    <Label>Category</Label>
                    <Select
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select a category</option>
                        {categories.map((category) => (
                            <option key={category} value={category}>
                                {category}
                            </option>
                        ))}
                    </Select>
                </FormGroup>

                <FormGroup>
                    <Label>Description</Label>
                    <TextArea
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Describe your item or service"
                        required
                    />
                </FormGroup>

                <FormGroup>
                    <Label>Price</Label>
                    <Input
                        type="text"
                        name="price"
                        value={formData.price}
                        onChange={handleInputChange}
                        placeholder="Enter price (e.g., $100 or $50/hour)"
                        required
                    />
                </FormGroup>

                <FormGroup>
                    <Label>Contact Information</Label>
                    <Input
                        type="text"
                        name="contact"
                        value={formData.contact}
                        onChange={handleInputChange}
                        placeholder="Email or phone number"
                        required
                    />
                </FormGroup>

                <FormGroup>
                    <Label>Location</Label>
                    <Input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                        placeholder="City, State"
                        required
                    />
                </FormGroup>

                <SubmitButton type="submit">
                    Create Listing
                </SubmitButton>
            </Form>
        </Container>
    );
};

export default CreateListing;